import StripeResultDialog from "@/components/StripeResultDialog";
import routes from "@/router/routes";
import { useState } from "react";

const SuccessPage = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(true);

    return (
        <StripeResultDialog
            buttonKey="stripe.success.continue"
            descriptionKey="stripe.success.description"
            isOpen={isDialogOpen}
            onOpenChange={setIsDialogOpen}
            redirectPath={routes.dashboard}
            titleKey="stripe.success.title"
            type="success"
        />
    );
};

export default SuccessPage;
